import React, { useEffect, useState } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

// Components
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import WaterBackground from './components/Layout/WaterBackground';
import LoadingScreen from './components/UI/LoadingScreen';
import WhatsAppFloat from './components/UI/WhatsAppFloat';

// Pages
import Home from './pages/Home';
import News from './pages/News';
import NewsDetail from './pages/NewsDetail';
import Gallery from './pages/Gallery';
import Faculty from './pages/Faculty';
import FacultyDetail from './pages/FacultyDetail';
import Courses from './pages/Courses';
import CourseDetail from './pages/CourseDetail';
import Contact from './pages/Contact';
import DepartmentFrontend from './pages/DepartmentFrontend';
import NotificationDetail from './pages/NotificationDetail';

const AppContent = () => {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 }
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <>
      <WaterBackground />
      <Header />
      <WhatsAppFloat />
      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          transition={{ duration: 0.4, ease: "easeOut" }}
        >
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/faculty" element={<Faculty />} />
            <Route path="/faculty/:id" element={<FacultyDetail />} />
            <Route path="/courses" element={<Courses />} />
            <Route path="/courses/:id" element={<CourseDetail />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/departments" element={<DepartmentFrontend />} />
            <Route path="/notification/:id" element={<NotificationDetail />} />
            {/* Fallback route for any unmatched routes */}
            <Route path="*" element={<Home />} />
          </Routes>
        </motion.main>
      </AnimatePresence>
      <Footer />
    </>
  );
};

function App() {
  return <AppContent />;
}

export default App;